import { render } from "./VoiceTestView.vue?vue&type=template&id=b45b3254"
import script from "./VoiceTestView.vue?vue&type=script&lang=js"
export * from "./VoiceTestView.vue?vue&type=script&lang=js"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__